import { Injectable, NgZone } from "@angular/core";
import { Observable, of, Subject, throwError, timer } from "rxjs";
import { map, catchError, repeatWhen, skip, takeUntil } from "rxjs/operators";
import {
  IHttpErrorPayload,
  HttpRequestPayload,
  IHttpSuccessPayload,
} from "@core/models";
import { HttpProviderService, HttpRequest } from "@fpx/core";
import {
  IcredentialsModel,
  ILoginauthPayLoad,
  ILoginauthResponseModel,
  IMPINLoginauthResponseModel,
  ITwoFactorResponseModel,
} from "./Pre-login.model";
import { AuthService } from "../auth.service";
import { CustomerService } from "../services/customer.service";
import { Router } from "@angular/router";
import { EPreloginServiceCode } from "../common/models/service-code.model";
import { UserService } from "../user.service";
import { NativeStorageService } from "../services/mobile/native-storage.service";
import { CommonService } from "../common.service";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class PreLoginService {
  customerCode: string;
  credentials: IcredentialsModel = null;
  twoFactor: ITwoFactorResponseModel;
  serviceName: string;
  flow: string = "login";
  serviceCode: string;
  showMainHeader: boolean = true;
  selfRegisterHeader: string = "Self Register";

  currentStage: string = "identifyYourself";
  completedStage: number = -1;
  selfRegisterStages: any = ["identifyYourself", "otp", "resetPassword"];
  refreshTokenService!: RefreshTokenService;
  userDetails:any;
  profileName:string;

  constructor(
    private _httpProvider: HttpProviderService,
    private _authService: AuthService,
    private _customerService: CustomerService,
    private _router: Router,
    public _userService: UserService,
    private _nativeStorage: NativeStorageService,
    private _commonService: CommonService,
    private zone: NgZone
  ) { }

  /// need to set from ARX token
  setUserDetails() { }

  setRefreshToken(refreshToken:string){
    sessionStorage.setItem('refreshToken', refreshToken);
  }

  setToken(loginauth) {
    this._userService.setToken(loginauth);
  }

  getCustomerCode() {
    return this.customerCode;
  }

  setCustomerCode(customerCode) {
    sessionStorage.setItem("customerCode", customerCode);
    sessionStorage.setItem("userId", customerCode);
    this.customerCode = customerCode;
  }
  updateProgessTab(currentStage) {
    this.currentStage = currentStage;
    this.completedStage = this.selfRegisterStages.indexOf(currentStage) - 1;
  }

  getPrimaryUser(): Promise<any> {
    return this._nativeStorage.retriveData("registeredUser");
  }

  setPrimaryUser(user:string) {
    this._nativeStorage.storeData("registeredUser", user).then((value) => {
      console.log("native storage set ~~~~>", value);
    })
    .catch((reason) => {
      console.log("native storage set error");
    });
  }

  getServiceName() {
    return this.serviceName;
  }
  setServiceName(serviceName) {
    this.serviceName = serviceName;
  }

  getUserTwoFactor() {
    return this.twoFactor;
  }
  setUserTwoFactor(twoFactor: ITwoFactorResponseModel) {
    this.twoFactor = { email: twoFactor.email, mobile: twoFactor.mobile };
  }

  doWelcome() {
    this._customerService
      .fetchCustomerInfo(this.customerCode)
      .subscribe((res) => {
        this._router.navigate(["welcome", "welcomeuser"]);
      });
  }

  setFlow(flow) {
    this.flow = flow;
  }
  getFlow() {
    return this.flow;
  }

  setServiceCode(serviceCode) {
    this.serviceCode = serviceCode;
  }
  getServiceCode() {
    return this.serviceCode;
  }

  login(payload: ILoginauthPayLoad): Observable<ILoginauthResponseModel> {

    const httpRequest:HttpRequest = new HttpRequest();
    httpRequest.setResource('/loginauth');
    httpRequest.setMethod('POST');
    httpRequest.setBody(payload);
    httpRequest.addHeaderParamter('Application', "BO");

    return this._httpProvider.invokeRestApi(httpRequest).pipe(
      map(
        (response: IHttpSuccessPayload<any>) => {
          const loginResponse: ILoginauthResponseModel = {
            responseBody: response.body,
            status: response.status,
          };
          this.setCustomerCode(loginResponse.responseBody.loginauth.userId);

          if (response.status == "201" || response.status == 201) {

            this.getPrimaryUser().then((value) => {
                // if (value.toUpperCase() != payload.loginauth.username.toUpperCase()) {
                if (value != payload.loginauth.username) {
                  //TODO: not a primary user
                }
                this.setUserTwoFactor({
                  email: loginResponse.responseBody.loginauth.twoFactor.email,
                  mobile: loginResponse.responseBody.loginauth.twoFactor.mobile,
                });
              })
              .catch((error) => {
                this.setUserTwoFactor({
                  email: loginResponse.responseBody.loginauth.twoFactor.email,
                  mobile: loginResponse.responseBody.loginauth.twoFactor.mobile,
                });
              });
            this.setUserTwoFactor({
              email: loginResponse.responseBody.loginauth.twoFactor.email,
              mobile: loginResponse.responseBody.loginauth.twoFactor.mobile,
            });
          }
          else if (response.status == "200" || response.status == 200) {
            this._commonService.setApplicationMode('RM');
            this.setToken(loginResponse.responseBody.loginauth);
            this.invokeRefreshTokenTimer(Number(loginResponse.responseBody.loginauth.expires_in));
          }

          if(this._commonService.isHybrid()) this.setPrimaryUser(payload.loginauth.username);

          this.setServiceName(EPreloginServiceCode.LOGINAUTH);
          this.setUserDetails();
          return loginResponse;
        },
        catchError((err: IHttpErrorPayload) => {
          return throwError(err);
        })
      )
    );
  }

  mpinLogin(payload: ILoginauthPayLoad): Observable<IMPINLoginauthResponseModel> {
    const httpRequest:HttpRequest = new HttpRequest();
    httpRequest.setResource('/mpinloginauth');
    httpRequest.setMethod('POST');
    httpRequest.setBody(payload);

    return this._httpProvider.invokeRestApi(httpRequest).pipe(
      map(
        (response: any) => {
          console.log("mpinlogin:", response.oe);

          const loginResponse: IMPINLoginauthResponseModel = {
            responseBody: response.body,
            status: response.status,
          };

          this.setRefreshToken(loginResponse.responseBody.mpinloginauth.refreshToken);
          this.setCustomerCode(loginResponse.responseBody.mpinloginauth.userId);

          if (response.status == "201" || response.status == 201) {
            this.setUserTwoFactor({
              email: loginResponse.responseBody.mpinloginauth.twoFactor.email,
              mobile: loginResponse.responseBody.mpinloginauth.twoFactor.mobile,
            });
          } else if (response.status == "200" || response.status == 200) {
            this.setToken(loginResponse.responseBody.mpinloginauth);
            this.invokeRefreshTokenTimer(Number(loginResponse.responseBody.mpinloginauth.expires_in));
          }

          this.setServiceName(EPreloginServiceCode.LOGINAUTH);
          this.setUserDetails();
          return loginResponse;
        },
        catchError((err: IHttpErrorPayload) => {
          return throwError(err);
        })
      )
    );
  }

  invokeRefreshTokenTimer(expires_in: number) {
    this.refreshTokenService = new RefreshTokenService(
      (Number(expires_in) - 120) * 1000
    );
    this.refreshTokenService?.observable$.subscribe({
      next: () => {
        console.log("timer");
        if (this._userService.getToken()) {
          this.refreshToken();
        } else {
          this.refreshTokenService.stop();
        }
      },
    });
  }

  refreshToken() {
    let userName;
    if(this._commonService.getApplicationMode()=='RM')
      userName= sessionStorage.getItem('username');
    else
      userName= sessionStorage.getItem('customerName');
    const httpRequest: HttpRequestPayload = {
      resource: "/iamtokenrefresh",
      method: "POST",
      body: {
        iamrefresh: {
            "userName": userName,
          "refreshToken": sessionStorage.getItem('refreshToken')
        }
      },
    };
    this._httpProvider.invokeApi(httpRequest).subscribe({
      next: (res: IHttpSuccessPayload<any>) => {
        this._userService.setAuthToken(res.body.authToken);
        this._userService.setRefreshToken(res.body.refreshToken);
      },
    });
  }

  logout(){
    if(this._commonService.getApplicationMode()=='RM'){
      this.iamLogoutuser().subscribe({
        next: (res)=>{
          this.clearSession();
          this.refreshTokenService?.stop();
          this.zone.run(() => {
            this._router.navigate(['login']);
        });
        },
        error: (error)=>{
          this.clearSession();
          this.refreshTokenService?.stop();
        }
      });
    }
    else{
      this.clearSession();
      this.refreshTokenService?.stop();
      this._commonService.exitApplication();
    }
    }
    clearSession(){
      if(this.currentStage != 'viewApplicationStatus') {
        let deviceId = sessionStorage.getItem('deviceId');
        sessionStorage.clear();
        sessionStorage.setItem("deviceId", deviceId);
        this._userService.removeToken();
        this.refreshTokenService?.stop();
      }
    }

    iamLogoutuser(): Observable<any>{
      let access_token = sessionStorage.getItem('access_token');
    const httpRequest = new HttpRequest();
    httpRequest.setMethod('POST');
    httpRequest.setResource('/userlogout');
    httpRequest.setServerContext(environment.commonPublisher);
    let bodyContent = {"userTicket":access_token};
    httpRequest.setBody(bodyContent);
    return this._httpProvider.invokeRestApi(httpRequest);
    }
    userProfile(){
      this.getUserDetails().subscribe({
        next:(res)=>{
          this.userDetails=res;
          this.profileName=this.userDetails?.firstName +" " + this.userDetails?.lastName;
        }
      });
    }
    getUserDetails(): Observable<any>{
      let user='USER';//sessionStorage.getItem('username');
    const httpRequest = new HttpRequest();
    httpRequest.setMethod('GET');
    httpRequest.setResource('/userprofile/{user}');
    httpRequest.setServerContext(environment.customersPublisher);
    httpRequest.addPathParameter('user',user);
    return this._httpProvider.invokeRestApi(httpRequest)
    .pipe(
      map(
        (res: IHttpSuccessPayload<any>) =>{
         return res.body
        //  return res.body.userprofile
        }
      )
    );
    }
}
export class RefreshTokenService {
  public observable$: Observable<any> = new Observable<any>();
  private readonly _stop = new Subject<void>();
  private readonly _start = new Subject<void>();

  constructor(refreshTime: number) {
    console.log(refreshTime)
    this.observable$ = timer(refreshTime, refreshTime).pipe(
      map(() => { }),
      takeUntil(this._stop),
      repeatWhen(() => this._start)
    );
  }

  start(): void {
    this._start.next();
  }
  stop(): void {
    this._stop.next();
  }
}
